import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row, Grid } from 'react-flexbox-grid'
import intersection from 'lodash/intersection'

import { ArrowDownRegions } from 'media/icons'
import SearchInput from 'components/SearchInput'
import DatePicker from 'components/DatePicker/DatePicker'
import alphabetSort from 'helpers/alphabetSort'
import { StyledHeaderContent } from 'style/styled'

import { isNumberBigHandler } from './BranchItem'
import { StyledHeader, StyledRegionListWrapper, StyledRegionCard, StyledRegionList } from './styled'
import MainPageSearch from 'components/MainPageSearch'


const Header = ({
	selectedRegion,
	setSelectedRegion,
	regionList,
	branchList,
	allowedShopsIds
}) => {
	const [t] = useTranslation()
	const [searchRegionInput, setSearchRegionInput] = useState('')
	const [modalVisible, setModalState] = useState(false) // region modal

	const onRegionCardClick = (regionId) => () => {
		setSelectedRegion(regionId)
		setModalState(false)
	}

	const regionName = !selectedRegion
		? t('common.strings.all_regions')
		: regionList.find((r) => r.id === selectedRegion)?.name

	return(
		<StyledHeader className='header_main'>
			<Grid className='defaultGrid'>
				<Row className='row headerRow '>
					<Col className='col col1' xl={3} md={4} sm={6}>
						<StyledHeaderContent modalVisible={modalVisible}>
							<h3>{t('dashboard_section.all_branches')}</h3>
							<span className='header_text'>
								<span
									className='all_regions'
									onClick={() => {
										setModalState((oldValue) => !oldValue)
									}}
								>
									{!selectedRegion ? t('common.strings.all_regions') : regionName}
									<span className='length'>{branchList.length}</span>
									<ArrowDownRegions />
								</span>
								{modalVisible && (
									<StyledRegionListWrapper>
										<SearchInput onSearch={setSearchRegionInput} />
										<StyledRegionList>
											{regionList
												.filter(({ name }) => !searchRegionInput || name.toLowerCase().includes(searchRegionInput.toLowerCase()))
												.sort(alphabetSort)
												.map((region) => {
													const isNumberBig = isNumberBigHandler(region.shops.length)
													return(
														<StyledRegionCard
															allRegions={region.allRegions}
															key={region.id}
															isNumberBig={isNumberBig}
															onClick={onRegionCardClick(region.id)}
														>
															<h3>{region.name}</h3>
															<span className='region_name'>
																{t('dashboard_section.active_branches')}:
																<span className='region-allowed_shops_count'>
																	{intersection(region.shops.map(({ id }) => id), allowedShopsIds).length}
																</span>
																<span className='region-all9_shops_count'>
																	/{region.shops.length}
																</span>
															</span>
														</StyledRegionCard>
													)
												})
												.concat(
													<StyledRegionCard
														allRegions={true}
														key={null}
														isNumberBig={isNumberBigHandler(`${allowedShopsIds.length}/${branchList.length}`)}
														onClick={onRegionCardClick(null)}
													>
														<h3>{t('common.strings.all_regions')}</h3>
														<span className='region_name'>
															{t('dashboard_section.active_branches')}:
															<span className='region-all9_shops_count'> {`${allowedShopsIds.length}/${branchList.length}`}</span>
														</span>
													</StyledRegionCard>
												)}
										</StyledRegionList>
									</StyledRegionListWrapper>
								)}
							</span>
						</StyledHeaderContent>
					</Col>
					<Col className='col col2' xl={3} xlOffset={0} md={4} mdOffset={4} sm={6}>
						<div className='header_item_date'>
							<DatePicker pickerType='date'/>
						</div>
					</Col>
					<Col className='col col3' xl={4} xlOffset={2} md={0} mdOffset={0}>
						<div className='header_item'>
							<MainPageSearch />
						</div>
					</Col>
				</Row>
			</Grid>
		</StyledHeader>
	)
}

export default Header
